<template>
  <div ref="basic_container">
    <!-- <div class="float-container">
      <transition>
        <div class="control-strip"
             v-show="stripShow">
          <el-col :span="14"
                  class="strip-left">
            <el-select v-model="optionValue"
                       :style='`width:${isfocus}`'
                       ref="select"
                       clearable
                       filterable
                       @visible-change="visibleChange"
                       placeholder="过滤">
              <el-option v-for="item in optionList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="9"
                  class="strip-right">
          </el-col>
        </div>
      </transition>
    </div> -->

    <div class="demo"
         ref="demo_container">
      <!-- avue常用配置 -->
      <el-card name="Avue 常用 option 参数说明"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">Avue 常用 option 参数说明 (蓝色底色为自定义扩展的属性)</span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>日常常用属性解释</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini" />
          </el-popover>
        </div>

        <div class="autocomplete-title"
             style="padding-left:30px"> 收集常用属性的配置，未涵盖的可参照avue官网。 扩展的属性需要混入文件（crudmixins）的支持，详细处理和说明可参照源码</div>
        <!-- 示例部分 -->
        <el-collapse v-model="activeNames.avueexplain">
          <el-collapse-item title="详细说明"
                            name="avueexplain">
            <avue-explain-demo v-if="activeNames.avueexplain=='avueexplain'"></avue-explain-demo>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 拼音码组件 -->
      <el-card name="拼音码组件"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">拼音码组件 <i>示例:AutocompleteResetDemo.vue</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>1. 解决极限状态先http紊乱问题</div>
            <div>2. 支持粘贴处理功能</div>
            <div>3. 支持辅助录入和自定义录入</div>
            <div>4. 高亮关键字</div>
            <div>5. 集成带出等方法</div>
            <div>6. 优化：简单功能友好的配置即使有，性能提升（默认数据的缓存）......</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <!-- 拼音码示例 -->
          <div class="autocomplete-title">一 . 原版支持用法</div>
          <autocomplete-reset-demo :notTypeUse="true"></autocomplete-reset-demo>

          <div class="autocomplete-title">二 . 简化版支持用法
            <span style="font-weight: 600;  font-size: 14px; color: #000;">( 1.仅是简化用法,原有参数及回调不变。2.默认配置详情或扩展配置 见desc说明或autocomplete-config.js #2022.11.1后得到支持)</span>
          </div>
          <autocomplete-reset-demo :notTypeUse="false"></autocomplete-reset-demo>
        </div>
        <el-collapse v-model="activeNames.activeNames1">
          <el-collapse-item title="@desc"
                            name="1">
            <div v-html="htmlValue(AutocompleteResetDesc)">
            </div>
          </el-collapse-item>
          <!-- <el-collapse-item title="@desc 简化版 "
                            name="2">
            <div v-html="htmlValue(AutocompleteResetDesc2)">
            </div>
          </el-collapse-item> -->
        </el-collapse>
      </el-card>
      <!-- 树形查询组件 -->
      <el-card name="树形查询组件"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">树形查询组件 <i>示例：SelectTreeDemo.vue</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>1. 与框架保持一致的样式</div>
            <div>2. 集成的处理回调</div>
            <div>3. 优化：简单功能友好的配置即使有，便捷统一管理......</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <select-tree-demo> </select-tree-demo>
        </div>
        <el-collapse v-model="activeNames.activeNames2">
          <el-collapse-item title="@desc"
                            name="1">
            <div v-html="htmlValue(SelectTreeDesc)"> </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 输入框组件 -->
      <el-card name="输入框组件"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">输入框组件（金额，重量等） <i>CustomInputDemo.vue</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>1. 与框架保持一致的样式</div>
            <div>2. 控制输入整数，小数及位数</div>
            <div>3. 使用场景:金额，重量等字段</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <custom-input-demo></custom-input-demo>
        </div>
        <el-collapse v-model="activeNames.activeNames7">
          <el-collapse-item title="@desc"
                            name="1">
            <div v-html="htmlValue(CustomInputDesc)"> </div>
          </el-collapse-item>
          <el-collapse-item title="@code"
                            name="2">
            <div>
              <prism-editor class="my-editor height-300"
                            :key="CustomInputCode"
                            v-model="CustomInputCode"
                            :highlight="highlighter"
                            readonly
                            line-numbers></prism-editor>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 对话框组件 -->
      <el-card name="对话框组件"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">对话框组件 <i>示例：DialogResetDemo.vue</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>1. 集成拖动功能，集成自动读取标题功能</div>
            <div>2. 常用属性的配置</div>
            <div>3. 优化：关于布局样式的优化，便捷统一管理......</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <dialog-resetDemo> </dialog-resetDemo>
        </div>
        <el-collapse v-model="activeNames.activeNames3">
          <el-collapse-item title="@desc"
                            name="1">
            <div v-html="htmlValue(DialogResetDesc)"> </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 时间类配置效果 -->
      <el-card name="查询时间类型配置及效果演示"
               class="box-card"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">查询时间类型配置及效果演示</span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>仅为模拟avue中配置后的效果， 自定义请参考实例的源码</div>
            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <date-demo></date-demo>
        </div>
        <el-collapse v-model="activeNames.activeNames7">
          <el-collapse-item title="@desc"
                            name="1">
            <div v-html="htmlValue(DateCodeDesc)"> </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>

      <!-- rich_element包 -->
      <el-card name="rich_element包"
               class="box-card external"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">rich_element <i>ElementUi源码维护版</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">
            <div>1. 该包将会迭代更新，想使用某些功能请关注更新文档</div>
            <div>2. 因npm原因废弃版本无法删除，请使用指定版本</div>

            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <div class="demoitem">
          <!-- rich_element说明 -->
          <el-table :data="tableData"
                    border
                    style="width: 100%">
            <el-table-column prop="ComponentsName"
                             width="180"
                             show-overflow-tooltip
                             label="组件名称">
              <template slot-scope="scope">
                <el-button type="text"
                           :disabled="scope.row.isRealize">{{scope.row.ComponentsName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="extend"
                             show-overflow-tooltip
                             label="扩展功能">
            </el-table-column>
            <el-table-column prop="versions"
                             show-overflow-tooltip
                             label="版本支持情况">
            </el-table-column>
            <el-table-column prop="explain"
                             show-overflow-tooltip
                             label="说明及注意事项">
            </el-table-column>
            <el-table-column prop="npm"
                             width="120"
                             label="npm下载地址">
              <template slot-scope="scope">
                <el-link type="primary"
                         @click="toLink(scope.row)">_地址</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-collapse v-model="activeNames.activeNames4">
          <el-collapse-item title="文档或更新日志"
                            name="1">
            <div v-html="htmlValue(RichElementDesc) "> </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- Avue源码 -->
      <el-card name="Avue源码维护版"
               class="box-card external"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">Avue源码维护版 <i>*已弃用，下次版本更新将完全删除</i></span>
          <el-popover placement="top-start"
                      width="350"
                      trigger="hover">

            <el-button slot="reference"
                       type="text"
                       icon="el-icon-info"
                       size="mini">
            </el-button>
          </el-popover>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <div v-html="htmlValue( `
         <del>框架层或业务层可以实现不要使用此方案。</del> 
         <del> 部分API或功能已经支持（查询前统一回调，重构表格区域适配方案....,未包含方案需要自己开发）</del> 。
         <del>  ##该方案目前搁置，却有需要索要源码 </del> 。
         <del> ##更新于 2022.09.30</del>  。
         ##考虑版本迭代该方案完全弃用 *2022.11.29`)">

          </div>
        </div>
        <el-collapse v-model="activeNames.activeNames6">
          <el-collapse-item title="文档或更新日志"
                            name="1">
            <div>
              待更新
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 扩展 -->
      <el-card name="了解更多/第三方库或仓库"
               class="box-card external"
               shadow="hover">
        <div slot="header"
             class="clearfix">
          <span class="card-title">了解更多 <i>第三方库或仓库</i></span>
        </div>
        <!-- 示例部分 -->
        <div class="demoitem">
          <extend-item></extend-item>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import AutocompleteResetDemo from './components/AutocompleteResetDemo.vue' // *拼音码使用示例
import SelectTreeDemo from './components/SelectTreeDemo.vue'  // *树组件使用示例
import DialogResetDemo from './components/DialogResetDemo.vue'  // *对话框示例
import ExtendItem from './components/ExtendItem.vue'  // *扩展模块组件
import CustomInputDemo from './components/CustomInputDemo.vue'  // *输入框组件
import AvueExplainDemo from './components/AvueExplainDemo.vue'  // *Avue常用属性说明
import DateDemo from './components/DateDemo.vue'  // * 时间类型组件配置演示
import { Desc, DescMethod } from './util/demodesc'   //日志及描述说明文件
DescMethod.initialize()
export default {
  components: {
    AutocompleteResetDemo,
    SelectTreeDemo,
    DialogResetDemo,
    PrismEditor: DescMethod.PrismEditor,
    ExtendItem,
    CustomInputDemo,
    AvueExplainDemo,
    DateDemo,
  },
  data() {
    return {
      isfocus: '20%',
      stripShow: true,
      optionValue: null,
      optionList: [],
      activeNames: {},
      tableData: Desc.tableData,  // rich_element更新功能及说明
      RichElementDesc: Desc.RichElementDesc,  // rich_element更新日志及使用方法
      AutocompleteResetDesc: Desc.AutocompleteResetDesc,  //AutocompleteReset拼音码 描述
      AutocompleteResetDesc2: Desc.AutocompleteResetDesc2,  //AutocompleteReset拼音码简化版 描述
      SelectTreeDesc: Desc.SelectTreeDesc,  //SelectTree 树形查询 描述
      DialogResetDesc: Desc.DialogResetDesc, //DialogReset 对话框 描述
      CustomInputDesc: Desc.CustomInputDesc, //CustomInput 输入框 描述
      DateCodeDesc: Desc.DateCodeDesc, //查询时间配置 描述
      DialogResetCode: Desc.DialogResetCode, //DialogReset对话框组件代码片段
      CustomInputCode: Desc.CustomInputCode, //CustomInput输入框组件代码片段
    };
  },
  mounted() {
    // const demo_container = this.$refs.demo_container
    // demo_container.addEventListener('scroll', () => {
    //   if (demo_container.scrollTop > 300) {
    //     this.$refs.select.blur()
    //     this.stripShow = false
    //   } else {
    //     this.stripShow = true
    //   }
    // })
    // const cardDom = Array.from(this.$el.querySelectorAll('.box-card'))
    // cardDom.forEach((item) => {
    //   const { attributes: { name } } = item
    //   this.optionList.push({ label: name.value, value: name.value })
    // })
  },
  methods: {
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    toLink(row) {
      window.open(row.npm, '_blank')
    },
    htmlValue(val) {
      return DescMethod.htmlValue(val)
    },
    visibleChange(type) {
      if (type)
        this.isfocus = '40%'
      else
        this.isfocus = '20%'
    }
  },
};
</script>

<style lang="scss" scoped>
$float-container-hg: 50px;
$padding-left-20: 20px;

::v-deep.padding-20 {
  padding-left: $padding-left-20;
}
.demo {
  height: calc(85vh);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px 30px;
  box-sizing: border-box;
  background-color: #fcfcfc;
  .box-card {
    margin-bottom: 15px;
    width: 100%;
  }
  .card-title {
    margin-right: 5px;
  }
}

::v-deep .el-icon-info {
  font-size: 18px;
}
::v-deep .el-card__header {
  font-weight: 900;
  background-color: #89c2ee;
}

.external {
  .el-card__header {
    font-weight: 900;
    background-color: #f59083 !important;
  }
}
.el-collapse-item__header {
  font-weight: 900 !important;
  font-size: 18px !important;
}
.demoitem {
  min-height: 60px;
  padding: 25px;
}
::v-deep .el-collapse-item__header:hover {
  transition: all 0.3s;
  font-size: 14px !important;
  box-shadow: 0 6px 4px -4px rgb(167, 167, 167);
}
::v-deep .el-link--inner {
  margin: 0 5px;
}
::v-deep .prism-editor-wrapper .prism-editor__container {
  background-color: #fafafa;
}

::v-deep.autocomplete-title {
  font-weight: 900 !important;
  font-size: 15px !important;
  margin: 15px 0;
  color: #409eff;
}

::v-deep .float-container {
  position: relative;
  width: 100%;
  height: $float-container-hg;
  background-color: #fcfcfc;
  .control-strip {
    position: absolute;
    top: 0;
    height: $float-container-hg;
    line-height: $float-container-hg;
    width: 100%;
    transition: all 0.2s;
    background-color: #fff;
    z-index: 9999;
    border-bottom: 1px solid #dcdfe6;
    .strip-left {
      text-align: right;
      padding: 0 20px;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.8s ease;
}
.v-enter,
.v-leave-to {
  transform: translateX(100px);
  opacity: 0;
}
</style> 
 
